module.exports = __webpack_public_path__ + "img/Number=68.a87eb321.png";